
const teamsShareLauncherUrl = 'https://teams.microsoft.com/share/launcher.js'

let alreadyAppendedScript

const appendTeamsScript = () => {
	const script = document.createElement('script')

	script.src = teamsShareLauncherUrl
	script.async = true

	document.body.appendChild(script)

	alreadyAppendedScript = script
}

const removeTeamsScript = () => {
	document.body.removeChild(alreadyAppendedScript)
}

export {
	appendTeamsScript,
	removeTeamsScript,
}
